import { apiGet, apiPut } from "./client";
import type { Profile } from "@career-ops-amplify/shared";
import type { ProfilePatch } from "@/types";

type ProfileResponse = { profile: Profile | null };
type ProfileUpdateResponse = { message?: string; profile: Profile };

/** Fetch the user's profile. */
export async function getProfile(): Promise<Profile> {
  const res = await apiGet<ProfileResponse>("/api/profile");
  return res.profile ?? ({} as Profile);
}

/** Partial update to the profile. */
export async function updateProfile(patch: ProfilePatch): Promise<Profile> {
  const res = await apiPut<ProfileUpdateResponse>("/api/profile", patch);
  return res.profile;
}